import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { watchForUpdates } from './lib/update.js'
import './styles.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

/* Registered after load so it never competes with the first paint. */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* No service worker just means no offline shell. The app still works. */
    })
  })
}

/* Asks on every resume whether a newer build is live, because an installed
   iOS app is resumed far more often than it is navigated. */
watchForUpdates()
